import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hrmsResetPassword } from '../../lib/hrmsApi';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Button } from '../../components/ui/button';
import { useToast } from '../../hooks/use-toast';
import { Loader2 } from 'lucide-react';

const HrmsReset = () => {
  const { toast } = useToast();
  const nav = useNavigate();
  const [pw, setPw] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast({ title: 'At least 8 characters' }); return; }
    setLoading(true);
    try {
      await hrmsResetPassword(pw);
      const u = JSON.parse(localStorage.getItem('hrms_user') || '{}');
      localStorage.setItem('hrms_user', JSON.stringify({ ...u, must_reset: false }));
      toast({ title: 'Password updated' });
      nav('/hrms');
    } catch { toast({ title: 'Failed to update' }); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-8">
        <h1 className="text-2xl font-extrabold">Set a new password</h1>
        <p className="text-sm text-slate-300 mt-1">You must change your temporary password before continuing.</p>
        <Label className="text-slate-200 mt-6 block">New password</Label>
        <Input value={pw} onChange={(e) => setPw(e.target.value)} type="password" className="h-11 mt-1 bg-white text-slate-900" placeholder="At least 8 characters" />
        <Button type="submit" disabled={loading} className="mt-5 w-full h-11 bg-orange-500 hover:bg-orange-600">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Update password'}
        </Button>
      </form>
    </div>
  );
};

export default HrmsReset;
